import React from "react";
import {getMessageTime} from "utilities/formatUtilities";
import {buildStyles} from "connectui/component/buildStyles";
import {useTheme} from "connectui/theme/ThemeProvider";
import FlexContainer from "connectui/component/layout/FlexContainer";
import Text from "connectui/component/display/Text";
import SvgIcon from "connectui/component/display/SvgIcon";
import ICONS from "connectui/icons/iconMap";

const useStyles = (theme) =>
  buildStyles({
    icon: {
      width: "19px",
      height: "19px",
      backgroundColor: theme.colors.gray200,
      color: theme.colors.textSecondary,
      borderRadius: "50%",
      padding: "3px",
    },
  });

const MessageNotification = ({
  message,
  notificationOnly,
  textColor = "textSecondary",
  actions = null,
  ...props
}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme);

  return (
    <FlexContainer
      flexDirection="column"
      alignItems={"center"}
      sx={{width: "100%"}}
    >
      {!notificationOnly && (
        <>
          <Text
            variant="textXS"
            color="textSecondary"
            sx={{textAlign: "center", marginBottom: theme.spacing(2)}}
          >
            {getMessageTime(message.sent)}
          </Text>
          <SvgIcon component={ICONS.zap} className={classes.icon} />
        </>
      )}
      <FlexContainer alignItems="center" gap={theme.spacing(1)}>
        <Text sx={{textAlign: "center"}} variant="textXS" color={textColor}>
          {message.message}
        </Text>
        {actions}
      </FlexContainer>
    </FlexContainer>
  );
};

export default MessageNotification;
